export function useFrontendAppVersion() {
    const versionFromEnv = process.env.REACT_APP_INFORMATIONAL_VERSION;

    if (versionFromEnv && versionFromEnv.length > 0) {
        return versionFromEnv;
    }

    return window.REACT_APP_INFORMATIONAL_VERSION;
}
